export default __webpack_public_path__ + "static/media/newPole.b57ab225.png";